import { Injectable } from '@angular/core';
import { GlobalService } from '../global.service';
import { Observable } from 'rxjs';

@Injectable()
export class DevicesService {

  constructor(private globalService: GlobalService) {}

  add(data: any): Observable<any> {
    return this.globalService.post('/SP-AddDevices/', data);
  }

  delete(id: string): Observable<any> {
    return this.globalService.post('/SP-DeleteDevice/', { id });
  }


  getByUser(idUser: string): Observable<any> {
    return this.globalService.post('/SP-GetDevicesByUser/', { idUser });
  }

  getAll(): Observable<any> {
    return this.globalService.get('/SP-GetAllDevices/');
  }

  getById(idMachine: string): Observable<any> {
    return this.globalService.post('/SP-GetDeviceById/', { idMachine });
  }

  toggleStatus(data: any): Observable<any> {
    return this.globalService.post('/SP-ToggleDeviceStatus/', data);
  }

  togglePhoneNumbersInitialized(data: any): Observable<any> {
    return this.globalService.post('/SP-InitPhoneNumbers/', data);
  }

  getPortsByDevice(idMachine: string): Observable<any> {
    return this.globalService.post('/SP-GetPortsByDevice/', { idMachine });
  }

  getAllPortsActivatedForUser(idUser: string): Observable<any> {
    return this.globalService.post('/SP-GetAllPortsActivatedForAnUser/', { idUser });
  }

  updateConnexion(data: any): Observable<any> {
    return this.globalService.post('/SP-UpdateConnexionDevice/', data);
  }

  updateUsingFor(data: any): Observable<any> {
    return this.globalService.post('/SP-UsingFor/', data);
  }

  updateName(data: { idMachine: string; name: string }): Observable<any> {
    return this.globalService.post('/SP-UpdateConnexionDevice/', { idMachine: data.idMachine, name: data.name });
  }

  countPendingSms(idMachine: string): Observable<any> {
    return this.globalService.post('/SP-GetPendingSMS/', { idMachine });
  }

  reloadDeliveredForDevice(idMachine: string): Observable<any> {
    return this.globalService.post('/SP-ReloadNotReallySend/', { idMachine });
  }

  toggleArchive(data: { idMachine: string; isArchive: boolean }): Observable<any> {
    return this.globalService.post('/SP-ToggleArchiveDevice/', data);
  }

  unlockAllLocks(): Observable<any> {
    return this.globalService.post('/SP-UnlockLocks/', {});
  }

}
